import { IActiveTaskFragment } from '../graphql/ActiveTaskFragment'

export const getSnoozedTask = (
  activeCeTasks: IActiveTaskFragment[] | undefined,
  activeCxTasks: IActiveTaskFragment[] | undefined
) => {
  const snoozedTasks = (activeCeTasks || [])
    .concat(activeCxTasks || [])
    .filter(({ snoozed }) => !!snoozed)
  const sortedTasks = snoozedTasks.sort((taskA, taskB) => {
    const taskASnoozedUntil = taskA?.snoozedUntil ? Date.parse(taskA?.snoozedUntil) : 0
    const taskBSnoozedUntil = taskB?.snoozedUntil ? Date.parse(taskB?.snoozedUntil) : 0
    // if snoozedUntil is the same, use the one that's due first
    if (taskASnoozedUntil === taskBSnoozedUntil) {
      const taskADueAt = taskA?.dueAt ? Date.parse(taskA?.dueAt) : 0
      const taskBDueAt = taskB?.dueAt ? Date.parse(taskB?.dueAt) : 0
      return taskADueAt - taskBDueAt
    }
    return taskASnoozedUntil - taskBSnoozedUntil
  })
  return sortedTasks[0] || null
}
